var OptionalUtils;
((OptionalUtils2) => {
  OptionalUtils2.mapIfPresent = (input, to) => {
    if (input === void 0 || input === null) {
      return void 0;
    } else {
      return to(input);
    }
  };
})(OptionalUtils || (OptionalUtils = {}));
export {
  OptionalUtils
};
//# sourceMappingURL=OptionalUtils.js.map
